export default __webpack_public_path__ + "static/media/Bitmap_5.e649787d.png";